import React from 'react'

const Promocoes = () => {
  return (
    <div>Promocoes</div>
  )
}
export default Promocoes;